// extracted by mini-css-extract-plugin
export default {"white-paper":"styles_white-paper__k7Kx1","white-paper__fresh":"styles_white-paper__fresh__a2qoM"};